import { getTextWidth } from "modules/shared/lib/charts"

type Props = {
  x: number
  y: number
  payload: {
    value: string
  }
  maxWidth: number
  dataLength?: number
}

const LINE_HEIGHT = 18

export const CustomChartLabel = ({ x, y, payload, maxWidth, dataLength }: Props) => {
  const label = payload.value

  const truncatedLabel = (text: string, width: number) => {
    if (getTextWidth(text) <= width) {
      return text
    }

    let truncated = text
    while (getTextWidth(`${truncated}...`) > width && truncated.length > 0) {
      truncated = truncated.slice(0, -1)
    }

    return `${truncated}...`
  }

  if (dataLength && dataLength > 6) {
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={4} textAnchor="end" fill="currentColor">
          <title>{label}</title>
          {truncatedLabel(label, maxWidth)}
        </text>
      </g>
    )
  }

  const words = label.split(" ")
  const lines = words.reduce((acc, word) => {
    const lastLine = acc[acc.length - 1]

    if (lastLine === undefined) {
      return [word]
    }

    const testLine = `${lastLine} ${word}`
    if (getTextWidth(testLine) <= maxWidth) {
      acc[acc.length - 1] = testLine
    } else {
      acc.push(word)
    }
    return acc
  }, [] as string[])

  const yOffset = (lines.length - 1) * (LINE_HEIGHT / 2)

  return (
    <g transform={`translate(${x},${y - yOffset})`}>
      <text x={0} y={0} textAnchor="end" fill="currentColor">
        <title>{label}</title>
        {lines.map((line, index) => (
          <tspan key={index} x={0} dy={index === 0 ? 4 : LINE_HEIGHT}>
            {truncatedLabel(line, maxWidth)}
          </tspan>
        ))}
      </text>
    </g>
  )
}
